import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, HostBinding, Input, Output, inject } from '@angular/core';

@Component({
  selector: 'kb-chip[type="filter"]',
  templateUrl: './filter-chip.component.html',
  styleUrls: ['./filter-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class FilterChipComponent {

  @Input()
  public get name(): string { return this._name; }
  public set name(value: string) {
    this._name = value;
    this.cdr.detectChanges(); // this is probably not good performance wise, but markForCheck does not work properly
  }
  private _name!: string;

  @Input()
  public value!: string;

  @Input()
  public tabIndex?: string;

  /** Whether the component is required. */
  @Input()
  public get required(): boolean { return this._required; }
  public set required(value: BooleanInput) { this._required = coerceBooleanProperty(value); }
  private _required = false;

  /** Whether the component is disabled. */
  @HostBinding('class.disabled') // for
  @Input()
  public get disabled(): boolean { return this._disabled; }
  public set disabled(value: BooleanInput) { this._disabled = coerceBooleanProperty(value); }
  private _disabled = false;

  /** Whether or not the option is currently checked. */
  @Input()
  public get checked(): boolean { return this._checked }
  public set checked(value: BooleanInput) {
    this._checked = coerceBooleanProperty(value);
    this.cdr.markForCheck();
  }
  private _checked = false;

  /** Event emitted when the option is checked or unchecked. */
  @Output()
  public readonly checkedChange = new EventEmitter<FilterChipComponent>();

  /** Event emitted when the option was touched. */
  @Output()
  public readonly touchedChange = new EventEmitter<FilterChipComponent>();

  private cdr = inject(ChangeDetectorRef);

  protected onInputChange(event: Event) {
    this.checked = (event.target as HTMLInputElement).checked;
    this.checkedChange.next(this);
  }

  protected onTouched() {
    this.touchedChange.next(this);
  }

}
